import React from 'react';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';
import Period from './Period';

const PeriodWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'Periodicidade',
            }}
        >
            <Period />
        </ServicesChartsDataProvider>
    );
};

export default PeriodWrapper;
